import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import pfiCustomModal from "../../../../src/content/pray-for-israel/customModalText";
import pfiCustomModalHeader from "../../../../src/content/pray-for-israel/customModalHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  pfiCustomModal,
  pfiCustomModalHeader,
  React
};